import { render, staticRenderFns } from "./CreateLoyaltyReward.vue?vue&type=template&id=27a6ed46&"
import script from "./CreateLoyaltyReward.vue?vue&type=script&lang=js&"
export * from "./CreateLoyaltyReward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports